import { NavLinks } from '@/types/navlink'

export const navLinks: NavLinks[] = [
  { label: 'Ana Sayfa', href: '/' },
  { label: 'Hizmetlerimiz', href: '#services' },
  { label: 'Biz Kimiz', href: '#about' },
  { label: 'Ekibimiz', href: '#team' },
  { label: 'Faaliyet Alanlarımız', href: '#activities' },
  { label: 'Bilgilendirme', href: '#faq' },
  { label: 'Bize Ulaşın', href: '/contactus' },
]
